export default __webpack_public_path__ + "static/media/card-outfitters.e87e10dc.png";